<template>
  <div class="organiser-form">
    <h2>Skapa Organisatör</h2>
    <form @submit.prevent="createOrganiser">
      <input v-model="name" placeholder="Namn" required />
      <input v-model="email" placeholder="E-post" required />
      <textarea v-model="description" placeholder="Beskrivning" />
      <input v-model="facebook" placeholder="Facebook användarnamn" />
      <input v-model="twitter" placeholder="Twitter användarnamn" />
      <input type="file" @change="uploadLogo" />
      <button type="submit">Skapa Organisatör</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      name: "", email: "", description: "",
      facebook: "", twitter: "", logoUrl: ""
    };
  },
  methods: {
    async uploadLogo(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("/api/upload", formData); // Du måste skapa denna backend om den inte finns
      this.logoUrl = res.data.url;
    },
    async createOrganiser() {
      await axios.post("/api/organiser/create", {
        name: this.name,
        email: this.email,
        description: this.description,
        facebook: this.facebook,
        twitter: this.twitter,
        logoUrl: this.logoUrl,
      });
      this.$router.push("/events");
    }
  }
};
</script>
